import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-playpause",
  "use": "icon-playpause-usage",
  "viewBox": "0 0 20 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 12\" id=\"icon-playpause\"><path d=\"M0 11.25V0l8.571 5.625L0 11.25Zm11.429-.268V.268h2.857v10.714h-2.857Zm5.714 0V.268H20v10.714h-2.857Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol